// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "assistant_suggestion_dismissal".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
/** Response atom for the "assistant_suggestion_dismissal" table (1:1 with a DB row, on the wire). */
export const assistantSuggestionDismissalAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    contentHash: z.string(),
    scopeSkillId: z.string().nullable(),
    createdAt: z.string().datetime(),
});
//# sourceMappingURL=assistantSuggestionDismissal.js.map